import React, { useState } from "react"
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { Accordion } from "@novaescola/eva-react-v2/lib/Accordion";

export function FaqSection ({ section }) {

	const [isAria, setAria] = useState(false);

	return (
		<section className="container-fluid eva-bg-inst-100" style={{ backgroundColor: section?.body?.backgroundColor }}>
			<div className="container common-questions">
				<div className="blocks eva-text-center">
					<Typography variant="title" size={4} asChild
						className="eva-margin-bottom-1"
						 style={{ color: section?.body?.textColor }}
					>
						<p>Perguntas frequentes</p>
					</Typography>
					<Typography variant="body" size={1} asChild
						className="eva-margin-bottom-4" style={{ color: section.body?.textColor }}
					>
						<p>Tire suas dúvidas sobre esse projeto</p>
					</Typography>
				</div>

					{section.body?.faq.map(( faq ) => (
						<div style={{marginBottom: 20}}>
							<Accordion
								onClick={() => setAria(!isAria)}
								aria-expanded={isAria ? true : false}
								label={faq.questionText}
      				>
      				  <Typography variant="body" size={2} asChild>
									<p>{faq.answerText}</p>
								</Typography>
      				</Accordion>
						</div>
					))}
			</div>
		</section>
	)
}